import type { PaymentMethod } from "@/models/types";

export const PAYMENT_METHODS: {
  value: PaymentMethod;
  label: string;
  icon: string;
}[] = [
  { value: "efectivo", label: "Efectivo", icon: "ri-cash-line" },
  { value: "tarjeta", label: "Tarjeta", icon: "ri-bank-card-line" },
  { value: "transferencia", label: "Transferencia", icon: "ri-exchange-line" },
  { value: "otro", label: "Otro", icon: "ri-more-2-line" },
];

export function paymentLabel(value: PaymentMethod): string {
  return PAYMENT_METHODS.find((p) => p.value === value)?.label ?? "Otro";
}

export function paymentIcon(value: PaymentMethod): string {
  return PAYMENT_METHODS.find((p) => p.value === value)?.icon ?? "ri-more-2-line";
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function uid(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}